import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class DiscountWorld extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	didMount() {
		const {
			rssFeedUrl,
		} = this.props;

		this.rssFeedUrl = rssFeedUrl;

		this.sectionTitle = this.element.querySelector('h2.sectionTitle');
		this.sectionDescription = this.element.querySelector('p.sectionDescription');
		this.sectionContent = this.element.querySelector('div.zsPartnersWrapper');

		this.getRssFeedData();
	}

	getRssFeedData = () => {
		let _self = this;
		let xhr = new XMLHttpRequest();
		xhr.open('GET', this.rssFeedUrl);
		xhr.onreadystatechange = function() {
			if(xhr.readyState === 4 ){
				if (xhr.status === 200) {
					_self.initFeedData(xhr.response)

				} else {
					_self.element.style.display = 'none';
					console.log(`Error ${xhr.status}: ${xhr.statusText}`);
				}
			}
		}
		xhr.send();
	}

	initFeedData = (data) => {
		let parseData = new window.DOMParser().parseFromString(data, "text/xml");
		let channel = parseData.querySelector('channel');
		let sectionTitle = channel.querySelector('sectionTitle');
		let sectionDescription = channel.querySelector('sectionDescription');
		sectionTitle ? this.sectionTitle.innerHTML = sectionTitle.textContent : null;
		sectionDescription ? this.sectionDescription.innerHTML = sectionDescription.textContent : null;
		let items = channel.querySelectorAll('item');
		let itemsHtml = '';
		for(let i = 0; i < items.length; i++) {
			let item = items[i];
			itemsHtml += `
				<article class="zsPartner">
					<a class="overridingLink" href="${item.querySelector('link').textContent}" target="_blank" title="${item.querySelector('title').innerHTML}"></a>
					${item.querySelector('featured').textContent}
					<div class="zsPartnerDescription">${item.querySelector('description').textContent}</div>
			`;
			const zlava = item.querySelector('zlava');
			const kod = item.querySelector('kod');
			if( zlava && zlava.textContent.length > 0 && kod && kod.textContent.length > 0 ) {
				itemsHtml += `
					<div class="zsPartnerInfo">
					   <span class="zsPartnerInfoZlava">ZĽAVA <b>${item.querySelector('zlava').textContent}</b></span>
					   <span class="zsPartnerInfoKod">KÓD <b>${item.querySelector('kod').textContent}</b></span>
					</div>`;
			}

			itemsHtml += `
				</article>
			`;
		}

		if(itemsHtml.length > 0) {
			this.sectionContent.innerHTML = itemsHtml;
		}

	}

	willUnMount() {
		this.elements = null;
	}
}

DiscountWorld.defaultProps = {
	rssFeedUrl: 'https://fpoho.sk/feed/?post_type=doxx_zlavovysvet',
}

export default DiscountWorld;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/DiscountWorld/DiscountWorld.js